<template>
    <div class="footer-additional">
        <div class="footer-additional__services">
            <a
                href="/for-individuals/online-applications"
                class="footer-additional__services__btn"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
                Онлайн - сервисы
            </a>
        </div>
        <div class="footer-additional__app-stores">
            <a
                href="https://apps.apple.com/ru/app/мобильный-банк-центр-инвест/id1479195238"
                class="footer-additional__app-stores__link"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
                <nuxt-img
                    src="icons/app-markets/footer/apple.svg"
                    alt="App Store"
                    loading="lazy"
                />
            </a>
            <!-- <a
                href="https://play.google.com/store/apps/details?id=ru.centrinvest.mobilebanking2018"
                class="footer-additional__app-stores__link"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
                <nuxt-img
                    src="icons/app-markets/footer/google.svg"
                    alt="Play Market"
                    loading="lazy"
                />
            </a> -->
            <a
                href="https://store.nashstore.ru/store/62cc37a00a39b24f4f8185b1"
                class="footer-additional__app-stores__link"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
                <nuxt-img
                    src="icons/app-markets/footer/nashstore.svg"
                    alt="Nashstore"
                    loading="lazy"
                />
            </a>
            <a
                href="https://apps.rustore.ru/app/ru.centrinvest.mobilebanking2018"
                class="footer-additional__app-stores__link"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
                <nuxt-img
                    src="icons/app-markets/footer/rustore.svg"
                    alt="rustore"
                    loading="lazy"
                />
            </a>
            <a
                href="https://appgallery.huawei.com/app/C107165091"
                class="footer-additional__app-stores__link"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
                <nuxt-img
                    src="icons/app-markets/footer/huawei.svg"
                    alt="rustore"
                    loading="lazy"
                />
            </a>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'FooterAdditional',
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/footer/footer-additional';
</style>
